// Spinner — inline indeterminate loading indicator. For brief in-place loads
// where a full skeleton is overkill (button busy state, small panels).
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { cx } from '../../../utils/cx';
import './spinner.css';

export function Spinner({ size = 'md', label, className }) {
  const { t } = useTranslation();
  return (
    <span
      className={cx('spinner', `spinner--${size}`, className)}
      role="status"
      aria-label={label ?? t('reusable.spinner.loading')}
    >
      <span className="spinner__ring" />
    </span>
  );
}

Spinner.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  label: PropTypes.string,
  className: PropTypes.string,
};

export default Spinner;
